const castThunk = a => {
  return typeof a === "function" ? a : () => a;
};
export { castThunk };
